<template>
	<div class="advert-manage-container">
		<!-- 数据卡片 -->
		<InfoCards :data="assetStats" />

		<div class="map-body" ref="box">
			<div id="container" style="width: 100%; height: 100%"></div>

			<div class="tool">
				<i
					:class="isFullscreen ? 'el-icon-close' : 'el-icon-full-screen'"
					style="padding: 4px 4px 8px 4px"
					@click="toggleFullscreen"></i>
				<div class="line"></div>
				<i class="el-icon-refresh-right" style="padding: 8px 4px 4px 4px"></i>
			</div>
			<div class="select">
				<el-select
					v-model="query.assetCategory"
					placeholder="请选择资产分类"
					clearable
					:popper-append-to-body="false"
					style="width: 100%"
					size="small">
					<el-option
						v-for="(item, index) in $menu.getList('AssetCategory')"
						:key="index"
						:label="item.name"
						:value="item.value" />
				</el-select>
				<el-select
					v-model="query.status"
					placeholder="请选择资产状态"
					clearable
					:popper-append-to-body="false"
					style="width: 100%; margin-top: 10px"
					size="small">
					<el-option
						v-for="(item, index) in $menu.getList('AssetStatus')"
						:key="index"
						:label="item.name"
						:value="item.value" />
				</el-select>
			</div>
			<div class="tip">
				<div class="tip-header">图例说明</div>
				<div class="tip-list">
					<div style="width: 10px; height: 10px; background-color: #67c23a; border-radius: 50%"></div>
					在用状态
				</div>
				<div class="tip-list">
					<div style="width: 10px; height: 10px; background-color: #909399; border-radius: 50%"></div>
					闲置状态
				</div>
				<div class="tip-list">
					<div style="width: 10px; height: 10px; background-color: #f56c6c; border-radius: 50%"></div>
					资产预警
				</div>
				<div class="tip-list">
					<div style="width: 10px; height: 10px; background-color: #409eff; border-radius: 50%"></div>
					已处置
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import AMapLoader from '@amap/amap-jsapi-loader';
	import dayjs from 'dayjs';
	import { getProjectStatistics } from '@/api/asset/assetLedgerApi';
	import { getCommunityId } from '@/utils/vc';
	window._AMapSecurityConfig = {
		securityJsCode: 'e184bf846c4427f3d414d762b64e13b5',
	};
	export default {
		name: 'AssetMap',
		data() {
			return {
				assetStats: [
					{
						key: 'totalCount',
						label: '项目资产量',
						unit: '项',
						color: '#5B8FF9',
						value: 6,
					},
					{
						key: 'area',
						label: '项目总面积',
						unit: '万㎡',
						color: '#5AD8A6',
						value: '16.6',
					},
					{
						key: 'inUseCount',
						label: '在用资产数',
						unit: '项',
						color: '#67C23A',
						value: 2,
						slot: {
							key: 'rate',
							label: '占比',
							unit: '%',
							color: '#67C23A',
							value: '33',
						},
					},
					{
						key: 'warningCount',
						label: '资产预警数',
						unit: '项',
						color: '#E8684A',
						value: 2,
					},
				],
				query: {
					assetCategory: '',
					status: '',
				},
				isFullscreen: false,
				list: [
					{
						status: '资产预警',
						statusType: 'warning',
						name: '园区广告牌A',
						code: 'GG-2026-001',
						company: '南京资管公司',
						type: '广告位',
						plan: '租赁经营',
						area: '45㎡',
						address: '江苏省南京市江宁区东山街道富塘路18号',
						tenant: '广告传媒公司',
						desc: '预警：租赁合同即将到期',
						detail: {
							warnReason: `租赁合同将于${dayjs().add(10, 'day').format('YYYY-MM-DD')}到期，需提前续约`,
							startDate: dayjs().subtract(1, 'year').add(10, 'day').format('YYYY-MM-DD'),
							endDate: dayjs().add(10, 'day').format('YYYY-MM-DD'),
						},
						lng: 118.8402,
						lat: 31.9526,
					},
					{
						status: '在用',
						statusType: 'success',
						name: '写字楼A座201室',
						code: 'FW-2026-002',
						company: '南京资管公司',
						type: '办公楼',
						plan: '租赁经营',
						area: '260㎡',
						address: '江苏省南京市江宁区双龙大道66号',
						tenant: '科技有限公司',
						desc: '租赁正常，无异常',
						detail: {
							startDate: dayjs().subtract(1, 'year').add(5, 'month').format('YYYY-MM-DD'),
							endDate: dayjs().add(5, 'month').format('YYYY-MM-DD'),
						},
						lng: 118.8421,
						lat: 31.9512,
					},
					{
						status: '闲置',
						statusType: 'info',
						name: '商业街商铺B1',
						code: 'SP-2026-003',
						company: '南京资管公司',
						type: '商铺',
						plan: '租赁经营',
						area: '98㎡',
						address: '江苏省南京市江宁区天元东路88号',
						tenant: '-',
						desc: '当前空置，待招商',
						detail: {},
						lng: 118.8453,
						lat: 31.9498,
					},
					{
						status: '已处置',
						statusType: 'danger',
						name: '旧厂房C区',
						code: 'CF-2026-004',
						company: '南京资管公司',
						type: '厂房',
						plan: '销售去化',
						area: '1800㎡',
						address: '江苏省南京市江宁区禄口工业园区',
						tenant: '-',
						desc: '资产已完成出售',
						detail: {
							disposeDate: '2025-12-20',
						},
						lng: 118.8368,
						lat: 31.9465,
					},
					{
						status: '资产预警',
						statusType: 'warning',
						name: '停车场D区',
						code: 'TC-2026-005',
						company: '南京资管公司',
						type: '停车场',
						plan: '租赁经营',
						area: '600㎡',
						address: '江苏省南京市江宁区胜太路100号',
						tenant: '停车运营公司',
						desc: '预警：收益下降明显',
						detail: {
							warnReason: '近3个月收益下降超过20%',
						},
						lng: 118.8415,
						lat: 31.9487,
					},
					{
						status: '在用',
						statusType: 'success',
						name: '园区仓库E栋',
						code: 'CK-2026-006',
						company: '南京资管公司',
						type: '仓储',
						plan: '自用',
						area: '1200㎡',
						address: '江苏省南京市江宁区秣陵街道工业区',
						tenant: '内部使用',
						desc: '用于公司物资存储',
						detail: {
							startDate: dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
						},
						lng: 118.8389,
						lat: 31.9472,
					},
				],
			};
		},
		created() {},
		mounted() {
			this.loadProjectStats();
			this.initMap();
		},
		methods: {
			dayjs,

			// 对接 AoAssetController.projectStatistics 接口
			// 把后端 ProjectAssetStatisticsVO 映射成 InfoCards 需要的 ledger-cards 结构
			loadProjectStats() {
				const cid = getCommunityId();
				if (!cid) return;
				getProjectStatistics(cid).then(res => {
					// request 拦截器已经做了 response.data.code==0 判断，res 就是 ProjectAssetStatisticsVO
					if (!res) return;
					const areaWan = res.totalBuildingArea
						? (Number(res.totalBuildingArea) / 10000).toFixed(1)
						: '0.0';
					const inUseRatio = res.inUseRatio !== null && res.inUseRatio !== undefined
						? Number(res.inUseRatio).toFixed(1)
						: '0.0';
					this.assetStats = [
						{
							key: 'totalCount',
							label: '项目资产量',
							unit: '项',
							color: '#5B8FF9',
							value: res.totalCount || 0,
						},
						{
							key: 'area',
							label: '项目总面积',
							unit: '万㎡',
							color: '#5AD8A6',
							value: areaWan,
						},
						{
							key: 'inUseCount',
							label: '在用资产数',
							unit: '项',
							color: '#67C23A',
							value: res.inUseCount || 0,
							slot: {
								key: 'rate',
								label: '占比',
								unit: '%',
								color: '#67C23A',
								value: inUseRatio,
							},
						},
						{
							key: 'warningCount',
							label: '资产预警数',
							unit: '项',
							color: '#E8684A',
							value: res.warningCount || 0,
						},
					];
				}).catch(err => {
					console.warn('loadProjectStats 失败（保持默认值）', err);
				});
			},

			initMap() {
				AMapLoader.load({
					key: 'ddf60f503491e1cffdc31b19322e9f4c',
					version: '2.0',
					plugins: ['AMap.Scale', 'AMap.Geolocation', 'AMap.PlaceSearch', 'AMap.AutoComplete', 'AMap.ToolBar'],
				})
					.then(AMap => {
						this.map = new AMap.Map('container', {
							viewMode: '2D',
							center: [113.65553, 34.748764],
							zoom: 12,
						});

						const toolbar = new AMap.ToolBar({
							position: 'LT',
						});
						const scale = new AMap.Scale();
						this.map.addControl(toolbar);
						this.map.addControl(scale);
						this.map.addControl(new AMap.Geolocation());

						this.auto = new AMap.AutoComplete({
							input: this.iptId,
						});
						this.placeSearch = new AMap.PlaceSearch({
							map: this.map,
							panel: 'panel', // 结果列表将在此容器中进行展示。
							// city: "010", // 兴趣点城市
							autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
							extensions: 'base', //返回基本地址信息
						});
						this.auto.on('select', this.select); //注册监听，当选中某条记录时会触发

						this.setMarker(AMap);
					})
					.catch(e => {
						console.log(e);
					});
			},
			createRippleMarker(status) {
				const colorMap = {
					normal: '#409EFF',
					warning: '#F56C6C',
					success: '#67C23A',
					info: '#909399',
				};

				const color = colorMap[status] || '#409EFF';

				if (status === 'warning') {
					return `
						<div class="ripple-marker" style="--color:${color}">
						<span class="dot"></span>
						<span class="ripple"></span>
						<span class="ripple delay"></span>
						</div>
					`;
				} else {
					return `
						<div class="ripple-marker" style="--color:${color}">
						<span class="dot"></span>
						</div>
					`;
				}
			},
			setMarker(AMap) {
				// 提示弹框（hover用）
				const hoverInfoWindow = new AMap.InfoWindow({
					// offset: new AMap.Pixel(0, -20),
					closeWhenClickMap: true,
					closeIcon: false,
					isCustom: true,
				});

				// 点击弹框
				const clickInfoWindow = new AMap.InfoWindow({
					// offset: new AMap.Pixel(180, 330),
					isCustom: true,
					closeWhenClickMap: true,
				});

				const markerList = [];

				this.list.forEach(item => {
					const marker = new AMap.Marker({
						position: [item.lng, item.lat],
						content: this.createRippleMarker(item.statusType || '#409EFF'),

						// `
						// 		<div style="
						// 		width:12px;
						// 		height:12px;
						// 		border-radius:50%;
						// 		background:${colorMap[item.statusType] || '#409EFF'};
						// 		border:2px solid #fff;
						// 		box-shadow:0 0 6px rgba(0,0,0,0.3);
						// 		"></div>
						// 	`,
					});

					// 🟡 鼠标移入
					marker.on('mouseover', () => {
						hoverInfoWindow.setContent(`
										<div class="map-card">
											<div class="title">
												${item.name}
												<span class="tag ${item.statusType}">${item.status}</span>
											</div>
											<div class="row">
												<span class="label">资产编号：</span>
												${item.code}
											</div>
											<div class="row">
												<span class="label">资产分类：</span>
												${item.type}
											</div>
											<div class="row">
												<span class="label">面积：</span>
												${item.area}
											</div>
											<div class="row">
												<span class="label">承租方：</span>
												${item.tenant}
											</div>
											<div class="desc">
												${item.desc}
											</div>
										</div>
									`);
						hoverInfoWindow.open(this.map, [item.lng, item.lat]);
					});

					// 🟡 鼠标移出
					marker.on('mouseout', () => {
						hoverInfoWindow.close();
					});

					// 🔵 点击
					marker.on('click', () => {
						hoverInfoWindow.close();
						clickInfoWindow.setContent(`
									<div class="map-card">

									<!-- 标题 -->
									<div class="title">
										${item.name}
										<span class="tag ${item.statusType}">${item.status}</span>
									</div>

									<!-- 副标题 -->
									<div class="sub">
										${item.type} · ${item.plan}
									</div>

									${item.detail.warnReason ? `<div class="warn">⚠ ${item.detail.warnReason}</div>` : ''}

									<!-- 基本信息 -->
									<div class="section">
										<div class="section-title">基本信息</div>

										<div class="row"><span>资产编号：</span>${item.code}</div>
										<div class="row"><span>所属公司：</span>${item.company}</div>
										<div class="row"><span>坐落位置：</span>${item.address}</div>
										<div class="row"><span>建筑面积：</span>${item.area}</div>
										<div class="row"><span>当前状态：</span>${item.status}</div>
									</div>

									<!-- 租赁信息 -->
									${
										item.tenant && item.tenant !== '-'
											? `
										<div class="section">
										<div class="section-title">租赁信息</div>

										<div class="row"><span>承租方：</span>${item.tenant}</div>
										<div class="row"><span>合同起始：</span>${item.detail.startDate || '-'}</div>
										<div class="row"><span>合同到期：</span>${item.detail.endDate || '-'}</div>
										</div>
									`
											: ''
									}

									</div>
								`);
						clickInfoWindow.open(this.map, [item.lng, item.lat]);
					});
					markerList.push(marker);
				});

				this.map.add(markerList);
				this.map.setFitView(markerList);
			},
			enterFullscreen(el) {
				if (el.requestFullscreen) {
					el.requestFullscreen();
				} else if (el.webkitRequestFullscreen) {
					el.webkitRequestFullscreen();
				} else if (el.msRequestFullscreen) {
					el.msRequestFullscreen();
				}
			},
			exitFullscreen() {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				}
			},
			toggleFullscreen() {
				const el = this.$refs.box;

				if (!document.fullscreenElement) {
					this.isFullscreen = true;
					this.enterFullscreen(el);
				} else {
					this.isFullscreen = false;
					this.exitFullscreen();
				}
			},
		},
	};
</script>

<style>
	.map-card {
		background-color: #fff;
		border-radius: 5px;
		padding: 12px 20px;
		min-width: 220px;
		font-size: 12px;
		color: #333;
	}

	.map-card .title {
		font-weight: bold;
		margin-bottom: 6px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.map-card .row {
		margin-bottom: 4px;
	}

	.map-card .label {
		color: #999;
	}

	.map-card .desc {
		margin-top: 6px;
		color: #666;
	}

	/* 状态标签 */
	.tag {
		font-size: 10px;
		padding: 2px 6px;
		border-radius: 4px;
		color: #fff;
	}

	.tag.success {
		background: #67c23a;
	}

	.tag.warning {
		background: #f56c6c;
	}

	.tag.info {
		background: #909399;
	}

	.tag.danger {
		background: #409eff;
	}

	.map-detail-card {
		width: 260px;
		font-size: 12px;
		color: #333;
	}

	.title {
		font-weight: bold;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		margin-bottom: 4px;
	}

	.sub {
		font-size: 12px;
		color: #666;
		margin-bottom: 6px;
	}

	.warn {
		background: #fff7e6;
		color: #e6a23c;
		padding: 4px 6px;
		border-radius: 4px;
		margin-bottom: 6px;
	}

	/* 分组 */
	.section {
		margin-top: 6px;
	}

	.section-title {
		font-weight: bold;
		margin-bottom: 4px;
	}

	/* 行 */
	.row {
		margin-bottom: 3px;
	}

	.row span {
		color: #999;
	}

	/* 状态标签 */
	.tag {
		font-size: 10px;
		padding: 2px 6px;
		border-radius: 4px;
		color: #fff;
	}

	.ripple-marker {
		position: relative;
		width: 25px;
		height: 25px;
	}

	.ripple-marker .dot {
		width: 25px;
		height: 25px;
		background: var(--color);
		border-radius: 50%;
		position: absolute;
		top: 5px;
		left: 5px;
		z-index: 2;
	}

	.ripple-marker .ripple {
		position: absolute;
		width: 33px;
		height: 33px;
		top: -1px;
		left: -1px;
		border: 2px solid var(--color);
		border-radius: 50%;
		animation: ripple 1.7s infinite;
		opacity: 0.6;
	}

	.ripple-marker .ripple.delay {
		animation-delay: 1.8s;
	}

	@keyframes ripple {
		0% {
			transform: scale(0.5);
			opacity: 0.8;
		}
		100% {
			transform: scale(2.2);
			opacity: 0;
		}
	}
</style>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
	}

	.map-body {
		margin-top: 15px;
		width: 100%;
		height: 71vh;
		border: 1px solid #eaeaea;
		border-radius: 12px;
		position: relative;

		.tool {
			position: absolute;
			top: 80px;
			left: 15px;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.6);
			border-radius: 5px;
			background-color: #fff;
			overflow: hidden;
			.line {
				width: 100%;
				height: 1px;
				background-color: #e8e8e8;
			}
			i {
				color: #000;
				display: block;
				font-size: 22px;
			}

			i:hover {
				background-color: #f0f0f0;
			}
		}
		.select {
			position: absolute;
			top: 10px;
			right: 10px;
			padding: 12px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			border-radius: 10px;
			background-color: #fff;
			width: 160px;
			z-index: 999;
		}

		.tip {
			position: absolute;
			bottom: 10px;
			right: 10px;
			padding: 8px 12px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			border-radius: 10px;
			background-color: #fff;
			&-header {
				font-size: 14px;
			}
			&-list {
				margin: 6px 0;
				font-size: 12px;
				color: #333;
				display: flex;
				gap: 10px;
				align-items: center;
			}
		}
	}
</style>